const tileLabel = {
    WAS_TODAY: 'browseui_tilePlayedToday',
    WAS_LAST_NIGHT: 'browseui_tilePlayedLastNight',
    WAS_YESTERDAY: 'browseui_tilePlayedYesterday',
    WAS_LAST_WEEK: 'browseui_tilePlayedLessThanWeekAgo',
    WAS_OVER_WEEK_AGO: 'browseui_tilePlayedMoreThanWeekAgo',
    IS_TODAY: 'browseui_tileLabelToday',
    WATCH_LIVE_TODAY: 'browseui_tileWatchLiveToday',
    IS_TODAY_EMBARGOED: 'browseui_tileWatchEmbargoedToday',
    IS_THIS_EVENING: 'browseui_tileWatchLiveThisEvening',
    IS_THIS_EVENING_EMBARGOED: 'browseui_tileWatchEmbargoedThisEvening',
    IS_TONIGHT: 'browseui_tileWatchLiveTonight',
    IS_TONIGHT_EMBARGOED: 'browseui_tileWatchEmbargoedTonight',
    IS_TOMORROW: 'browseui_tileWatchLiveTomorrow',
    IS_TOMORROW_EMBARGOED: 'browseui_tileWatchEmbargoedTomorrow',
    IS_THIS_WEEK: 'browseui_tileWatchLiveLessThanWeekAway',
    IS_THIS_WEEK_EMBARGOED: 'browseui_tileWatchEmbargoedLessThanWeekAway',
    IS_OVER_WEEK_AWAY: 'browseui_tileWatchLiveMoreThanWeekAway',
    IS_OVER_WEEK_AWAY_EMBARGOED: 'browseui_tileWatchEmbargoedMoreThanWeekAway',
    IS_LIVE: 'browseui_tileStarted',
    FALLBACK: 'browseui_tilePlayedMoreThanWeekAgo',
    FEATURE_METADATA_STRING: 'browseui_onFeatureTournamentTitle',
    TOMORROW_TIME: 'tile_label_redesign_tomorrow',
    UPCOMING_REDESIGN: 'tile_label_redesign_upcoming',
    CATCHUP_REDESIGN: 'tile_label_redesign_catchup',
    TODAY_TIME: 'tile_label_redesign_today',
    TIME: 'tile_label_redesign_time',
    DAY_TIME: 'tile_label_redesign_day_time',
    DATE_YEAR: 'tile_label_redesign_date_year',
    YESTERDAY: 'tile_label_redesign_yesterday'
};

const calendar = {
    MONDAY_LONG: 'date_mondayLong',
    MONDAY_LONG_UPPERCASE: 'date_mondayLongUppercase',
    MONDAY_LONG_PROPERCASE: 'date_mondayLongPropercase',
    MONDAY_SHORT: 'date_mondayShort',
    MONDAY_SHORT_UPPERCASE: 'date_mondayShortUppercase',
    MONDAY_SHORT_PROPERCASE: 'date_mondayShortPropercase',
    TUESDAY_LONG: 'date_tuesdayLong',
    TUESDAY_LONG_UPPERCASE: 'date_tuesdayLongUppercase',
    TUESDAY_LONG_PROPERCASE: 'date_tuesdayLongPropercase',
    TUESDAY_SHORT: 'date_tuesdayShort',
    TUESDAY_SHORT_UPPERCASE: 'date_tuesdayShortUppercase',
    TUESDAY_SHORT_PROPERCASE: 'date_tuesdayShortPropercase',
    WEDNESDAY_LONG: 'date_wednesdayLong',
    WEDNESDAY_LONG_UPPERCASE: 'date_wednesdayLongUppercase',
    WEDNESDAY_LONG_PROPERCASE: 'date_wednesdayLongPropercase',
    WEDNESDAY_SHORT: 'date_wednesdayShort',
    WEDNESDAY_SHORT_UPPERCASE: 'date_wednesdayShortUppercase',
    WEDNESDAY_SHORT_PROPERCASE: 'date_wednesdayShortPropercase',
    THURSDAY_LONG: 'date_thursdayLong',
    THURSDAY_LONG_UPPERCASE: 'date_thursdayLongUppercase',
    THURSDAY_LONG_PROPERCASE: 'date_thursdayLongPropercase',
    THURSDAY_SHORT: 'date_thursdayShort',
    THURSDAY_SHORT_UPPERCASE: 'date_thursdayShortUppercase',
    THURSDAY_SHORT_PROPERCASE: 'date_thursdayShortPropercase',
    FRIDAY_LONG: 'date_fridayLong',
    FRIDAY_LONG_UPPERCASE: 'date_fridayLongUppercase',
    FRIDAY_LONG_PROPERCASE: 'date_fridayLongPropercase',
    FRIDAY_SHORT: 'date_fridayShort',
    FRIDAY_SHORT_UPPERCASE: 'date_fridayShortUppercase',
    FRIDAY_SHORT_PROPERCASE: 'date_fridayShortPropercase',
    SATURDAY_LONG: 'date_saturdayLong',
    SATURDAY_LONG_UPPERCASE: 'date_saturdayLongUppercase',
    SATURDAY_LONG_PROPERCASE: 'date_saturdayLongPropercase',
    SATURDAY_SHORT: 'date_saturdayShort',
    SATURDAY_SHORT_UPPERCASE: 'date_saturdayShortUppercase',
    SATURDAY_SHORT_PROPERCASE: 'date_saturdayShortPropercase',
    SUNDAY_LONG: 'date_sundayLong',
    SUNDAY_LONG_UPPERCASE: 'date_sundayLongUppercase',
    SUNDAY_LONG_PROPERCASE: 'date_sundayLongPropercase',
    SUNDAY_SHORT: 'date_sundayShort',
    SUNDAY_SHORT_UPPERCASE: 'date_sundayShortUppercase',
    SUNDAY_SHORT_PROPERCASE: 'date_sundayShortPropercase',
    JANUARY_LONG: 'date_januaryLong',
    JANUARY_LONG_UPPERCASE: 'date_januaryLongUppercase',
    JANUARY_LONG_PROPERCASE: 'date_januaryLongPropercase',
    JANUARY_SHORT: 'date_januaryShort',
    JANUARY_SHORT_UPPERCASE: 'date_januaryShortUppercase',
    JANUARY_SHORT_PROPERCASE: 'date_januaryShortPropercase',
    FEBRUARY_LONG: 'date_februaryLong',
    FEBRUARY_LONG_UPPERCASE: 'date_februaryLongUppercase',
    FEBRUARY_LONG_PROPERCASE: 'date_februaryLongPropercase',
    FEBRUARY_SHORT: 'date_februaryShort',
    FEBRUARY_SHORT_UPPERCASE: 'date_februaryShortUppercase',
    FEBRUARY_SHORT_PROPERCASE: 'date_februaryShortPropercase',
    MARCH_LONG: 'date_marchLong',
    MARCH_LONG_UPPERCASE: 'date_marchLongUppercase',
    MARCH_LONG_PROPERCASE: 'date_marchLongPropercase',
    MARCH_SHORT: 'date_marchShort',
    MARCH_SHORT_UPPERCASE: 'date_marchShortUppercase',
    MARCH_SHORT_PROPERCASE: 'date_marchShortPropercase',
    APRIL_LONG: 'date_aprilLong',
    APRIL_LONG_UPPERCASE: 'date_aprilLongUppercase',
    APRIL_LONG_PROPERCASE: 'date_aprilLongPropercase',
    APRIL_SHORT: 'date_aprilShort',
    APRIL_SHORT_UPPERCASE: 'date_aprilShortUppercase',
    APRIL_SHORT_PROPERCASE: 'date_aprilShortPropercase',
    MAY_LONG: 'date_mayLong',
    MAY_LONG_UPPERCASE: 'date_mayLongUppercase',
    MAY_LONG_PROPERCASE: 'date_mayLongPropercase',
    MAY_SHORT: 'date_mayShort',
    MAY_SHORT_UPPERCASE: 'date_mayShortUppercase',
    MAY_SHORT_PROPERCASE: 'date_mayShortPropercase',
    JUNE_LONG: 'date_juneLong',
    JUNE_LONG_UPPERCASE: 'date_juneLongUppercase',
    JUNE_LONG_PROPERCASE: 'date_juneLongPropercase',
    JUNE_SHORT: 'date_juneShort',
    JUNE_SHORT_UPPERCASE: 'date_juneShortUppercase',
    JUNE_SHORT_PROPERCASE: 'date_juneShortPropercase',
    JULY_LONG: 'date_julyLong',
    JULY_LONG_UPPERCASE: 'date_julyLongUppercase',
    JULY_LONG_PROPERCASE: 'date_julyLongPropercase',
    JULY_SHORT: 'date_julyShort',
    JULY_SHORT_UPPERCASE: 'date_julyShortUppercase',
    JULY_SHORT_PROPERCASE: 'date_julyShortPropercase',
    AUGUST_LONG: 'date_augustLong',
    AUGUST_LONG_UPPERCASE: 'date_augustLongUppercase',
    AUGUST_LONG_PROPERCASE: 'date_augustLongPropercase',
    AUGUST_SHORT: 'date_augustShort',
    AUGUST_SHORT_UPPERCASE: 'date_augustShortUppercase',
    AUGUST_SHORT_PROPERCASE: 'date_augustShortPropercase',
    SEPTEMBER_LONG: 'date_septemberLong',
    SEPTEMBER_LONG_UPPERCASE: 'date_septemberLongUppercase',
    SEPTEMBER_LONG_PROPERCASE: 'date_septemberLongPropercase',
    SEPTEMBER_SHORT: 'date_septemberShort',
    SEPTEMBER_SHORT_UPPERCASE: 'date_septemberShortUppercase',
    SEPTEMBER_SHORT_PROPERCASE: 'date_septemberShortPropercase',
    OCTOBER_LONG: 'date_octoberLong',
    OCTOBER_LONG_UPPERCASE: 'date_octoberLongUppercase',
    OCTOBER_LONG_PROPERCASE: 'date_octoberLongPropercase',
    OCTOBER_SHORT: 'date_octoberShort',
    OCTOBER_SHORT_UPPERCASE: 'date_octoberShortUppercase',
    OCTOBER_SHORT_PROPERCASE: 'date_octoberShortPropercase',
    NOVEMBER_LONG: 'date_novemberLong',
    NOVEMBER_LONG_UPPERCASE: 'date_novemberLongUppercase',
    NOVEMBER_LONG_PROPERCASE: 'date_novemberLongPropercase',
    NOVEMBER_SHORT: 'date_novemberShort',
    NOVEMBER_SHORT_UPPERCASE: 'date_novemberShortUppercase',
    NOVEMBER_SHORT_PROPERCASE: 'date_novemberShortPropercase',
    DECEMBER_LONG: 'date_decemberLong',
    DECEMBER_LONG_UPPERCASE: 'date_decemberLongUppercase',
    DECEMBER_LONG_PROPERCASE: 'date_decemberLongPropercase',
    DECEMBER_SHORT: 'date_decemberShort',
    DECEMBER_SHORT_UPPERCASE: 'date_decemberShortUppercase',
    DECEMBER_SHORT_PROPERCASE: 'date_decemberShortPropercase'
};

const timeInfo = {
    DATE_ISO_TIME: 'dateISO_time',
    DATE_12_HOUR_FORMAT: 'date_12_hour_format'
};

const externalServices = {
    roblox: {
        url: 'https://authorize.roblox.com',
        authUrl: 'https://apis.roblox.com/oauth/v1/token',
        userIdUrl: 'https://apis.roblox.com/oauth/v1/userinfo',
        redirectParams: {
            clientId: '4035339545582643922',
            responseType: 'code',
            scope: 'openid',
            state: '6789',
            nonce: '1236',
            redirectUrl: window.location.origin + window.location.pathname
        },
        authParams: {
            clientSecret:
                'RBX-Y_WvgRm0o0yZ0jefmpAfqkaLAmnHh5KB0Mc8sW3wAhRZozybdxXffDhlWkYJYuSY',
            grantType: 'authorization_code'
        },
        robloxIdName: 'robloxId',
        buttonId: 'roblox',
        contentfulPage: 'boxing-beta',
        errorId: 'ROBLOX ID ERROR',
        signUpchapterPath: '/account/content/DAZN/signup',
        signUpchapterData: {
            billingPeriod: 'Instalments',
            entitlementSetId: 'tier_gold_de'
        }
    }
};

export {tileLabel, calendar, timeInfo, externalServices};
